import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import StoryPlayer from '../components/StoryPlayer';
import { FASTAPI_HOST } from '../settings/config';

// 支持通过 props 或 URL 查询参数传 storyId
export default function StoryPlayerPage(props) {
  const [media, setMedia] = useState([]);
  const [storyTitle, setStoryTitle] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [currentLang, setCurrentLang] = useState('English');
  const [translations, setTranslations] = useState({});
  const handlePracticeTalking = (context) => {
    sessionStorage.setItem('marstrix_practice_context', JSON.stringify({
      ...context,
      storyId,
    }));
    window.location.assign('/protected?practice=story');
  };

  // 优先 props.storyId，其次 URL 查询参数
  let storyId = props.storyId;
  if (!storyId) {
    const params = new URLSearchParams(window.location.search);
    storyId = params.get('storyId') || '';
  }

  useEffect(() => {
    fetch('/translations.json')
      .then((response) => response.json())
      .then(setTranslations)
      .catch((error) => console.warn('Failed to load translations:', error));

    const userToken = Cookies.get('user_token');
    if (!userToken) return;
    fetch(`${FASTAPI_HOST}/api/user-preferences`, {
      headers: { Authorization: `Bearer ${userToken}` },
    })
      .then((response) => response.ok
        ? response.json()
        : Promise.reject(new Error(`HTTP ${response.status}`)))
      .then((preferences) => {
        if (preferences?.ui_language) setCurrentLang(preferences.ui_language);
      })
      .catch((error) => console.warn('Failed to load UI language:', error));
  }, []);

  useEffect(() => {
    // IMPORTANT:
    // - If a storyId is provided (URL query or props), it must win.
    // - sessionStorage "preview" is only for the /story-player route opened without a storyId.
    if (storyId) {
      // Prevent stale preview in the opener tab from affecting storyId-based opens.
      sessionStorage.removeItem('story_player_preview');
    } else {
      const storedPreview = sessionStorage.getItem('story_player_preview');
      if (storedPreview) {
        try {
          const parsed = JSON.parse(storedPreview);
          if (parsed?.media && Array.isArray(parsed.media)) {
            sessionStorage.removeItem('story_player_preview');
            setMedia(parsed.media);
            setStoryTitle(parsed.storyTitle || 'Generated Story');
            setErrorMessage('');
            return;
          }
        } catch (e) {
          console.error('Invalid story player preview data', e);
        }
      }
    }

    async function fetchStory() {
      try {
        // 新接口: /api/story/{storyId}/media_info 返回 { media, title, ... }
        const userToken = Cookies.get('user_token');
        const res = await fetch(`${FASTAPI_HOST}/api/story/${storyId}/media_info`, {
          headers: {
            Authorization: userToken ? `Bearer ${userToken}` : undefined,
          },
        });
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        const data = await res.json();
        setMedia(data.media || []);
        setStoryTitle(data.title || '');
        setErrorMessage('');
      } catch (e) {
        console.error('Failed to fetch story media_info:', e);

        // Show a simple in-page message instead of mock data
        setMedia([]);
        setStoryTitle('');
        setErrorMessage('Error in loading. Story might be unavailable or you might not have access.');
      }
    }

    if (storyId) {
      fetchStory();
    }
  }, [storyId]);

  return (
    <div className="min-h-screen bg-transparent">
      {errorMessage ? (
        <div className="p-4">
          <div className="rounded border border-red-300 bg-red-50 px-4 py-3 text-red-800">
            {errorMessage}
          </div>
        </div>
      ) : null}

      <StoryPlayer
        media={media}
        storyTitle={storyTitle}
        onPracticeTalking={handlePracticeTalking}
        practiceLabel={translations?.[currentLang]?.scenario_practice || ''}
      />
    </div>
  );
}
